/**
 * AUTHORIZED  - the athlete has granted all the necessary permissions and is ready to fetch data
 * DATA_FETCHED - the athlete has granted all the necessary permissions and data has been fetched successfully
 * ERROR - an error occurred while fetching or processing data
 * INITIATED - social hook has been attached to the component
 * READY - external partner JS has been injected or verified to be present on the page
 * REQUEST_PERMISSION - athlete needs to grant permissions for the request to take place
 * REQUEST_NEW_PERMISSION - the athlete needs to grant more permissions for the request to proceed
 * UNAUTHORIZED - the athlete has denied giving permissions after being prompted to do so
 */
export const AuthorizationStatus = Object.freeze({
  AUTHORIZED: 'AUTHORIZED',
  DATA_FETCHED: 'DATA_FETCHED',
  ERROR: 'ERROR',
  INITIATED: 'INITIATED',
  READY: 'READY',
  REQUEST_PERMISSIONS: 'REQUEST_PERMISSIONS',
  REQUEST_NEW_PERMISSIONS: 'REQUEST_NEW_PERMISSIONS',
  UNAUTHORIZED: 'UNAUTHORIZED'
});

export default { AuthorizationStatus };
